/**
 * Persist Orders search filters (sessionStorage) so returning from order edit keeps the same criteria.
 */

export const ORDERS_SEARCH_STORAGE_KEY = 'icct.ordersSearch.filters.v1';

const SNAPSHOT_VERSION = 1;

/**
 * Shape matches OrdersSearchPage filter state (+ results prefs).
 */
export function buildOrdersSearchSnapshot(filters) {
  return {
    v: SNAPSHOT_VERSION,
    rangePreset: filters.rangePreset ?? 'all',
    startDate: filters.startDate ?? '',
    endDate: filters.endDate ?? '',
    q: filters.q ?? '',
    status: filters.status ?? '',
    paymentMethods: Array.isArray(filters.paymentMethods) ? filters.paymentMethods : [],
    minTotal: filters.minTotal ?? '',
    maxTotal: filters.maxTotal ?? '',
    channel: filters.channel ?? '',
    staff: filters.staff ?? '',
    guest: filters.guest ?? '',
    notes: filters.notes ?? '',
    selectedProducts: (Array.isArray(filters.selectedProducts) ? filters.selectedProducts : []).map((p) => ({
      id: p.id,
      name: p.name,
      sku: p.sku,
    })),
    selectedVariations: (Array.isArray(filters.selectedVariations) ? filters.selectedVariations : []).map((x) => ({
      id: x.id,
      product_id: x.product_id,
      sku: x.sku,
      display_name: x.display_name,
      attributes: x.attributes,
      price_num: x.price_num,
    })),
    page: filters.page ?? 1,
    perPage: filters.perPage ?? 25,
    sortBy: filters.sortBy ?? 'date',
    sortDir: filters.sortDir ?? 'desc',
    ordersView: filters.ordersView === 'zelle' ? 'zelle' : 'search',
  };
}

export function loadOrdersSearchSnapshotFromSession() {
  try {
    const raw = sessionStorage.getItem(ORDERS_SEARCH_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || o.v !== SNAPSHOT_VERSION) return null;
    return o;
  } catch {
    return null;
  }
}

export function saveOrdersSearchSnapshotToSession(snapshot) {
  try {
    sessionStorage.setItem(ORDERS_SEARCH_STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    /* ignore quota / privacy mode */
  }
}

export function clearOrdersSearchSnapshotFromSession() {
  try {
    sessionStorage.removeItem(ORDERS_SEARCH_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
